"use client";
import CloseButton from "./CloseButton";
import {MouseEventHandler} from "react";
import Banner from "../types/Banner";

export type HelloBarProps = {
	banner?: Banner;
	isVisible?: boolean;
	onCloseButtonClick: MouseEventHandler<HTMLButtonElement> &
		MouseEventHandler<HTMLElement>;
};

const HelloBar: React.FC<HelloBarProps> = ({
	banner,
	isVisible,
	onCloseButtonClick,
}) => {
	if (!banner || !isVisible) {
		return;
	}

	return (
		<div
			id="hello-bar"
			className="top-0 z-hello-bar flex w-full items-center justify-center gap-4 bg-green-800 px-4 py-2 text-center font-light text-corporate-gray-100"
		>
			<div
				className="flex-auto"
				dangerouslySetInnerHTML={{__html: banner.content}}
			></div>
			<div>
				<CloseButton onClick={onCloseButtonClick} />
			</div>
		</div>
	);
};

export default HelloBar;
